<div class="user-info">
  @if (displayInfo()) {
    <span
      class="initials"
      [ngStyle]="{
        'background-color': color(),
      }"
      >{{ initials }}</span
    >
  }
  <div class="name-wrapper">
    @if (displayInfo()) {
      <div class="name">{{ name() }} <{{ email() }}></div>
    }
    <div class="gem-container">
      <canvas #canvas style="width: 100%; height: 4px"></canvas>
    </div>
  </div>
</div>
